import type { PlaceCardData } from '../../lib/conversationsApi';
import './placeCard.css';
import { PlacePhoto } from './PlacePhoto';

export function PlaceCard({ place }: { place: PlaceCardData }) {
  return (
    <section className="ozira-place-card" aria-label={`Location for ${place.name}`}>
      <div className="ozira-place-card__brand"><span>OZIRA Live</span><strong>Google Maps</strong><span className="ozira-place-card__verified">Verified</span></div>
      {place.photoUrl ? (
        <PlacePhoto key={place.photoUrl} className="ozira-place-card__photo" url={place.photoUrl} name={place.name} />
      ) : null}
      <div className="ozira-place-card__body">
        <div className="ozira-place-card__pin" aria-hidden="true">●</div>
        <div>
          {place.type ? <p className="ozira-place-card__type">{place.type}</p> : null}
          <h3>{place.name}</h3>
          <p>{place.address}</p>
          <small>{place.latitude.toFixed(5)}, {place.longitude.toFixed(5)}</small>
        </div>
      </div>
      {place.mapTileUrl ? (
        <img className="ozira-place-card__maptile" src={place.mapTileUrl} alt="" aria-hidden="true" loading="lazy" />
      ) : null}
      <div className="ozira-place-card__actions">
        <a href={place.mapsUrl} target="_blank" rel="noreferrer">Open in Google Maps</a>
        {place.websiteUrl ? <a className="is-secondary" href={place.websiteUrl} target="_blank" rel="noreferrer">Website</a> : null}
      </div>
      <p className="ozira-place-card__attribution" translate="no">Google Maps</p>
    </section>
  );
}
